module.exports = __webpack_public_path__ + "../resources/img/ic_re_smartthings_guide_step2_img.d132f520.svg";